import { useTranslation } from 'react-i18next'

import { Badge, Typography } from '@percent/lemonade'
import { useAuth } from '@percent/workplace-giving/common/hooks'
import { getCountryCodeFromAuthState } from '@percent/workplace-giving/context/auth/authContextController/AuthContextController'

export type FeaturedBadgeProps = {
  featured?: {
    featuredItemId: string
    country: string[]
  }
}

export function FeaturedBadge({ featured }: Readonly<FeaturedBadgeProps>) {
  const { t } = useTranslation()
  const { state } = useAuth()
  const userCountryCode = getCountryCodeFromAuthState(state)
  const isFeaturedInUserCountry =
    featured && (featured.country.length === 0 || (userCountryCode && featured.country.includes(userCountryCode)))

  if (!isFeaturedInUserCountry) {
    return null
  }

  return (
    <Badge variant="positive" testId="featured-badge" shape="oval">
      <Typography>{t('workplace_giving.common.featured')}</Typography>
    </Badge>
  )
}
